define(function(require) {
    'use strict';

    var defineComponent = require('flightjs').component;

    function UserSwitcher() {

        this.defaultAttrs({
            radioSelector : 'input[type=radio][name=userid]'
        });

        this.after('initialize', function() {
            this.on(
                this.$node.select('radioSelector'),
                'change',
                this.submitForm
            );
        });

        this.submitForm = function() {
            this.$node.closest('form').submit();
        };
    }

    return defineComponent(UserSwitcher);
});



/** WEBPACK FOOTER **
 ** ./~/@99designs/brand-container/lib/ui/user-switcher.js
 **/